import { clientDomain } from '@utils/environment'

// FIXME: This is a temporary solution. We need to find a better way to handle cookies in the future.
export class Cookies {
  static setCookie(name: string, value: string, days = 1) {
    let expires = ''
    if (days) {
      const date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expires = `; expires=${date.toUTCString()}`
    }
    if (typeof document !== 'undefined')
      document.cookie = `${name}=${value}${expires}; path=/; domain=.${clientDomain}`
  }

  static getCookie(name: string) {
    const nameEQ = `${name}=`
    if (typeof document !== 'undefined') {
      const ca = document.cookie.split(';')
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1, c.length)
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
      }
    }
    return null
  }

  static eraseCookie(name: string) {
    if (typeof document !== 'undefined') {
      document.cookie = `${name}=; Max-Age=-99999999; path=/; domain=.${clientDomain}`
    }
  }
}
